import useSWR from 'swr'

import { getClusterOrgId } from '~/api'

export function useParentClusterOrgId(
  parentClusterId?: string
): string | undefined {
  const { data } = useSWR(
    parentClusterId ? ['cluster-org-by-id', parentClusterId] : null,
    () => getClusterOrgId(parentClusterId!)
  )
  return data
}
